// extracted by mini-css-extract-plugin
export default {"container":"accordion_container__1oAlv","toggle":"accordion_toggle__1dIeP","button":"accordion_button__1foMi"};